import {keyframes} from "@mui/material";

export const SNAP_SIZE = 16;
export const GRID_SIZE = SNAP_SIZE;
export const GRID_MAJOR_SIZE = 64;

export const ZOOM_STEP = 10;
export const ZOOM_MIN = 5;
export const ZOOM_MAX = 200;
export const PAN_STEP = 50;


export const ALIGNMENT_OFFSET_GAP = 64;

export const DUPLICATE_OFFSET = GRID_MAJOR_SIZE;
export const TABLE_CAPACITY_MAX = 20;
export const TABLE_DROP_SIZE = 120;
export const TABLE_MIN_SIZE = 85;
export const RESIZE_SCALE_EPSILON = 0.001;
export const MIN_SHAPE_WIDTH = 10;
export const MIN_SHAPE_HEIGHT = 10;
export const MIN_TEXT_FONT_SIZE = 8;
export const MIN_WALL_LENGTH = 32;


export const pulseHighlight = keyframes`
    0% {
        background-color: rgba(25, 118, 210, 0.35);
        box-shadow: inset 0 0 0 2px rgba(25, 118, 210, 0.5);
    }
    50% {
        background-color: rgba(25, 118, 210, 0.2);
        box-shadow: inset 0 0 0 2px rgba(25, 118, 210, 0.3);
    }
    100% {
        background-color: transparent;
        box-shadow: none;
    }
`;

export const DRAG_BORDER_OK = 'rgba(102, 187, 106, 1)';
export const DRAG_BORDER_FULL = 'rgba(239, 83, 80, 1)';
export const DRAG_BG_OK = 'rgba(102, 187, 106, 0.08)';
export const DRAG_BG_FULL = 'rgba(239, 83, 80, 0.08)';

export const OVER_BORDER_OK = 'rgba(102, 187, 106, 1)';
export const OVER_BORDER_FULL = 'rgba(239, 83, 80, 1)';
export const OVER_BG_OK = 'rgba(102, 187, 106, 0.48)';
export const OVER_BG_FULL = 'rgba(239, 83, 80, 0.48)';
